import {ContentCommentLikeDomain} from "../../domain/content/ContentCommentLikeDomain"

export const ContentCommentLikeDescriptor: Record<keyof ContentCommentLikeDomain, (o: ContentCommentLikeDomain) => string> = {
    id(o: ContentCommentLikeDomain): string {
        return o.id.toString()
    },
    contentCommentId(o: ContentCommentLikeDomain): string {
        return o.contentCommentId.toString()
    },
    userId(o: ContentCommentLikeDomain): string {
        return o.userId.toString()
    },
    createdAt(o: ContentCommentLikeDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    }
}
